import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  accessToken: string | null;
  role: 'admin' | 'customer' | null;
  isAuthChecked: boolean;
  customer_id: number | null; 
}

const initialState: AuthState = {
  accessToken: null,
  role: null,
  isAuthChecked: false,
  customer_id: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAccessToken(state, action: PayloadAction<string>) {
      state.accessToken = action.payload;
    },
    setRole(state, action: PayloadAction<'admin' | 'customer'>) {
      state.role = action.payload;
    },
    setIsAuthChecked(state, action: PayloadAction<boolean>) {
      state.isAuthChecked = action.payload;
    },
    setCustomerId(state, action: PayloadAction<number>) {
      state.customer_id = action.payload;
    },
    clearAccessToken(state) {
      state.accessToken = null;
      state.role = null;
      state.customer_id = null;
    },
  },
});

export const { setAccessToken, setRole, setIsAuthChecked, setCustomerId, clearAccessToken } = authSlice.actions;
export default authSlice.reducer;